__turbopack_context__.v({
  "control": "_38KbJW_control",
  "controlFocused": "_38KbJW_controlFocused",
  "customSelect": "_38KbJW_customSelect",
  "disabled": "_38KbJW_disabled",
  "dropdownIndicator": "_38KbJW_dropdownIndicator",
  "indicatorRotated": "_38KbJW_indicatorRotated",
  "indicators": "_38KbJW_indicators",
  "inputSearchSelect": "_38KbJW_inputSearchSelect",
  "menu": "_38KbJW_menu",
  "multiValue": "_38KbJW_multiValue",
  "multiValueRemove": "_38KbJW_multiValueRemove",
  "option": "_38KbJW_option",
  "optionFocused": "_38KbJW_optionFocused",
  "optionSelected": "_38KbJW_optionSelected",
  "placeholder": "_38KbJW_placeholder",
  "singleValue": "_38KbJW_singleValue",
  "slideDown": "_38KbJW_slideDown",
  "valueContainer": "_38KbJW_valueContainer",
});
